interface RenoLensVisualizerProps {
  clientId?: string;
  height?: string | number;
  industries?: string[];
  removeBranding?: boolean;
  hideExitButton?: boolean;
  className?: string;
}

export default function RenoLensVisualizer({
  clientId = 'RL-TBF2Q9KZ',
  height = 800,
  industries = ['kitchen-bath', 'landscaping', 'roofing', 'bathroom'],
  removeBranding = true,
  hideExitButton = true,
  className = '',
}: RenoLensVisualizerProps) {
  const heightStyle = typeof height === 'number' ? `${height}px` : height;
  
  // Build the iframe URL with query parameters
  const industriesParam = industries.join(',');
  const iframeUrl = `https://renolens.com/embed/${clientId}?industries=${industriesParam}&removeBranding=${removeBranding}&hideExitButton=${hideExitButton}`;

  return (
    <div className={`renolens-container ${className}`}>
      <div style={{ position: 'relative' }}>
        <iframe
          src={iframeUrl}
          style={{
            width: '100%',
            height: heightStyle,
            border: 'none',
          }}
          allow="camera; microphone; fullscreen"
          title="RenoLens Visualizer"
        />
        <a
          href="https://renolens.com"
          style={{
            position: 'absolute',
            left: '-9999px',
            width: '1px',
            height: '1px',
            overflow: 'hidden',
          }}
          aria-hidden="true"
        >
          AI Visualizer
        </a>
      </div>
    </div>
  );
}

